import EventLink from "components/atoms/Links/EventLink/EventLink";
import SeasonSlide from "components/atoms/Sliders/SeasonSlide/SeasonSlide";
import DefaultSlide from "components/atoms/Sliders/DefaultSlide/DefaultSlide";
import TrailerSlide from "components/atoms/Sliders/TrailerSlide/TrailerSlide";
import MiniArticle from "components/molecules/MiniArticle/MiniArticle";
import DiscussionLink from "components/atoms/Links/DiscussionLink/DiscussionLink";
import RecommendationLink from "components/molecules/RecommendationLink/RecommendationLink";

export const LeftWidgets = [
    {
        title: "MALxJapan -More than just anime-",
        linkTitle: "Visit MALxJapan",
        link: "https://mxj.myanimelist.net/",
        slider: false,
        display: "flex",
        Atom: EventLink,
        items: [
            {
                img: "https://cdn.myanimelist.net/images/mxj/20220325/bp.png",
                title: "Blue Period Art Contest merchandise is now available for pre-order! 🎨",
                link: "https://mxj.myanimelist.net/bpart/?utm_source=MAL&utm_medium=top-mxj&utm_content=bpart",
            },
            {
                img: "https://cdn.myanimelist.net/images/mxj/20220325/furuba.jpg",
                title: "Tohru and co. take the stage in Fruits Basket the Stage! Get your tickets 🍙",
                link: "https://mxj.myanimelist.net/m-fruba/?utm_source=MAL&utm_medium=top-mxj&utm_content=m-fruba",
            },
            {
                img: "https://cdn.myanimelist.net/images/mxj/20220328/nbcu.png",
                title: "Vote for your favorite NBCUniversal in the Anime General Election! 🗳",
                link: "https://mxj.myanimelist.net/nbcuniversal_animexmusic30thproject/generalelection_anime/?utm_source=MAL&utm_medium=top-mxj&utm_content=nbcu",
            },
        ],
    },
    {
        title: "Spring 2022 Anime",
        linkTitle: "View More",
        link: "https://myanimelist.net/anime/season",
        Atom: SeasonSlide,
        slider: true,
        slides: 4.5,
        items: [
            {
                title: "Tate no Yuusha no Nariagari Season 2",
                link: "https://myanimelist.net/anime/40356/Tate_no_Yuusha_no_Nariagari_Season_2",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1143/121873.jpg?s=53e5307c692813dd82a264ecfa16f130",
            },
            {
                title: "Kaguya-sama wa Kokurasetai: Ultra Romantic",
                link: "https://myanimelist.net/anime/43608/Kaguya-sama_wa_Kokurasetai__Ultra_Romantic",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1430/118919.jpg?s=373826daf531718e4b97d14ba1c284ea",
            },
            {
                title: "Spy x Family",
                link: "https://myanimelist.net/anime/50265/Spy_x_Family",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1440/121382.jpg?s=eab87e3e5c6ff589f780a7bc6fb1f6b2",
            },
            {
                title: "Komi-san wa, Comyushou desu. 2nd Season",
                link: "https://myanimelist.net/anime/50631/Komi-san_wa_Comyushou_desu_2nd_Season",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1108/121157.jpg?s=b0a1d30c717341e221735a27caec1f33",
            },
            {
                title: "Kawaii dake ja Nai Shikimori-san",
                link: "https://myanimelist.net/anime/45613/Kawaii_dake_ja_Nai_Shikimori-san",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1995/121695.jpg?s=8c54a737ad6bbea0340184dabbfdd5ae",
            },
            {
                title: "Date A Live IV",
                link: "https://myanimelist.net/anime/41461/Date_A_Live_IV",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1368/121281.jpg?s=4d330f2248939fbb311a5db8d847e740",
            },
            {
                title: "Aharen-san wa Hakarenai",
                link: "https://myanimelist.net/anime/49520/Aharen-san_wa_Hakarenai",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1612/120636.jpg?s=e7a98e1391b5b25dc7bd0598dc1f960f",
            },
            {
                title: "Kakkou no Iinazuke",
                link: "https://myanimelist.net/anime/48675/Kakkou_no_Iinazuke",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1285/120529.jpg?s=ef8810ea6501774780fdaed4a3119eae",
            },
            {
                title: "Rikei ga Koi ni Ochita no de Shoumei shitemita. Heart",
                link: "https://myanimelist.net/anime/43470/Rikei_ga_Koi_ni_Ochita_no_de_Shoumei_shitemita_Heart",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1109/118948.jpg?s=9a18bc5c4baf0fb0d3442cecb7eb48dd",
            },
            {
                title: "Honzuki no Gekokujou: Shisho ni Naru Tame ni wa Shudan wo Erandeiraremasen 3rd Season",
                link: "https://myanimelist.net/anime/42429/Honzuki_no_Gekokujou__Shisho_ni_Naru_Tame_ni_wa_Shudan_wo_Erandeiraremasen_3rd_Season",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1976/122302.webp?s=1dbc29beb05a2cc18e389bc12602f115",
            },
            {
                title: "Gaikotsu Kishi-sama, Tadaima Isekai e Odekakechuu",
                link: "https://myanimelist.net/anime/48760/Gaikotsu_Kishi-sama_Tadaima_Isekai_e_Odekakechuu",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1361/120706.jpg?s=22bc38be9475997fffc3c580dc3e5ff7",
            },
            {
                title: "Yuusha, Yamemasu",
                link: "https://myanimelist.net/anime/50175/Yuusha_Yamemasu",
                img: "https://cdn.myanimelist.net/r/320x440/images/anime/1934/122301.webp?s=54a6cf40c5f216ce84607acaf7e7ab56",
            },
            {
                title: "Summertime Render",
                link: "https://myanimelist.net/anime/47194/Summertime_Render",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1120/120796.jpg?s=ee890e66b92233de9e6f4499a4b1b73f",
            },
            {
                title: "Shijou Saikyou no Daimaou, Murabito A ni Tensei suru",
                link: "https://myanimelist.net/anime/48415/Shijou_Saikyou_no_Daimaou_Murabito_A_ni_Tensei_suru",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1904/120095.jpg?s=db8d1893f61f7cda5232eacce788e33d",
            },
            {
                title: "Tomodachi Game",
                link: "https://myanimelist.net/anime/50273/Tomodachi_Game",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1247/121345.jpg?s=032510721fd0289bdb590782c5a28567",
            },
            {
                title: "Bubble",
                link: "https://myanimelist.net/anime/50549/Bubble",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1011/121152.jpg?s=1e5c4180acb4a53c95e204b7dbc4b04d",
            },
            {
                title: "Mahoutsukai Reimeiki",
                link: "https://myanimelist.net/anime/48842/Mahoutsukai_Reimeiki",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1093/121114.jpg?s=a8de7bc3ef1c30b762939a10b6fc5e6f",
            },
            {
                title: "Otome Game Sekai wa Mob ni Kibishii Sekai desu",
                link: "https://myanimelist.net/anime/50461/Otome_Game_Sekai_wa_Mob_ni_Kibishii_Sekai_desu",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1688/121121.jpg?s=cec9707e391417a2d390cc9e57e1a47d",
            },
            {
                title: "Machikado Mazoku: 2-choume",
                link: "https://myanimelist.net/anime/42745/Machikado_Mazoku__2-choume",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1036/121135.jpg?s=dc53bca72c33a974b54eac5f53e78751",
            },
            {
                title: "Koi wa Sekai Seifuku no Ato de",
                link: "https://myanimelist.net/anime/48643/Koi_wa_Sekai_Seifuku_no_Ato_de",
                img: "https://cdn.myanimelist.net/r/160x220/images/anime/1347/120593.jpg?s=3b01d3c63d8e0a4d4f340b42a5ede6ac",
            },
        ],
    },
    {
        title: "Manga Store",
        linkTitle: "View More",
        link: "https://myanimelist.net/store",
        Atom: DefaultSlide,
        slider: true,
        slides: 6.5,
        items: [
            {
                link: "https://myanimelist.net/store/manga/229/Peach_Mermaid?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/1944/4580376309d4ad621c44f8558c0ee060d0897688253b6ef5c6630a978fc0a441/l.jpg?s=83d272b04300042a9f1dd17b1831a4d8",
                title: "Peach Mermaid",
            },
            {
                link: "https://myanimelist.net/store/manga/793/CHOW_DOWN_CHAMPS?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/7094/bdc2b72d55f0c4b5bfab34f8dd063b7419c5ec70ca67421e641f335c6bed7bbc/l.jpg?s=9792c296bc3df36748f6ff3872017500",
                title: "CHOW DOWN CHAMPS",
            },
            {
                link: "https://myanimelist.net/store/manga/148/Hozukis_Coolheadedness?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/1707/c8281e4e4882cb4b2451e38c1b753a69283a33d0069b60fe9b08d32d5b8eef7e/l.jpg?s=e4b9450528df3ad82dc7fb172fb560f9",
                title: "Hozuki's Coolheadedness",
            },
            {
                link: "https://myanimelist.net/store/manga/680/Konosuba__An_Explosion_on_This_Wonderful_World?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/5641/776ac7ba4db329e189a73c198c80a7a80e906ca64c031f4941c5093df499b09e/l.jpg?s=a0da4a895043b915600359d3a87186a8",
                title: "Konosuba: An Explosion on This Wonderful World!",
            },
            {
                link: "https://myanimelist.net/store/manga/57/Nodame_Cantabile?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/1238/17a4835e5fd5ae16b119b92785c0024f5e327b12f728fe29ab4c171a46988b56/l.jpg?s=86a10126de81b22804a2c4d3e09534cf",
                title: "Nodame Cantabile",
            },
            {
                link: "https://myanimelist.net/store/manga/593/PERFECT_DOUBLE?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/4814/8c3d141b15a992724ee00b48c37e7b71f84c6d7015819a6253fcaeec48933d75/l.jpg?s=753e214efbccf3fc3aa2b0d7e219f6dc",
                title: "PERFECT DOUBLE",
            },
            {
                link: "https://myanimelist.net/store/manga/684/My_Youth_Romantic_Comedy_Is_Wrong_As_I_Expected__comic?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/5695/05e349ed841ed712a74f660b56b4df649743f9bd07c4dd9d51f829cb8ee0c266/l.jpg?s=682d157695d39fcf363cc30f00430300",
                title: "My Youth Romantic Comedy Is Wrong, As I Expected @ comic",
            },
            {
                link: "https://myanimelist.net/store/manga/611/Cocoon_Entwined?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/4880/36531de4967ec1b117a2c71069e563fe93f87d213fc1d01fa6ba4a4e133f9a3a/l.jpg?s=de6de5aa8ca75feff045a6e844d748d4",
                title: "Cocoon Entwined",
            },
            {
                link: "https://myanimelist.net/store/manga/70/Cells_at_Work?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/1367/0a8f4f9e7cbdfa6a3f5ca40e471df8a00ae3963a1b3894ea5a23d2a83f6ed9cd/l.jpg?s=289d1318c15c53db267f07643666287c",
                title: "Cells at Work!",
            },
            {
                link: "https://myanimelist.net/store/manga/847/Sword_Art_Online_light_novel?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/7670/157ad1492573c26e24dce3e5adbce178d2efa676e7963715b818550ea9cc8c7e/l.jpg?s=20ee68225fcaaceea4de2978c068d696",
                title: "Sword Art Online (light novel)",
            },
            {
                link: "https://myanimelist.net/store/manga/298/JUDGE?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/2375/ae07053cae8718f50617f87b0750f4137c34f191c8817443bfb4f0f8f2248bfd/l.jpg?s=408a3244b5bb3039580eb9e0f3cf3fbb",
                title: "JUDGE",
            },
            {
                link: "https://myanimelist.net/store/manga/827/THE_WATCH_CATS_OF_GINZA?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/7265/b4a570193cd1c5791039e9fb8a7990e79d4159e7ecf13b6961af5e7b55793e80/l.jpg?s=44c1e9d566fd1b51b5529e664075ec42",
                title: "THE WATCH CATS OF GINZA",
            },
            {
                link: "https://myanimelist.net/store/manga/1131/Falling_Drowning?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/9975/5f37d4e95173be928e02bc5b07ce76219aa04b71160c6d40f66265dfb8cf0ca1/l.jpg?s=69f7dac066bd446a9125379eb5bea940",
                title: "Falling Drowning",
            },
            {
                link: "https://myanimelist.net/store/manga/1121/HIRAETH_-The_End_of_the_Journey-_1?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/9924/ff2e9629795f7b42f10b52704aac865c9bf2d5a4a754475434978c715cf0a746/l.jpg?s=ee281efb3848c29102714518c48da9b7",
                title: "HIRAETH -The End of the Journey- 1",
            },
            {
                link: "https://myanimelist.net/store/manga/1020/A_Witchs_Love_at_the_End_of_the_World?_location=mal_mid_slider",
                img: "https://cdn.myanimelist.net/r/108x163/s/common/store/cover/9076/6d8037560ab2699c7dd7627620061050b1b172d50f97ed050d0336c89bca19af/l.jpg?s=4b93c61d97519d3003fc6dbc1edb7199",
                title: "A Witch's Love at the End of the World",
            },
        ],
    },
    {
        title: "Latest Updated Episode Videos",
        linkTitle: "View More",
        link: "https://myanimelist.net/watch/episode",
        Atom: DefaultSlide,
        slider: true,
        slides: 6.5,
        items: [
            {
                title: "Fantasy Bishoujo Juniku Ojisan to",
                link: "https://myanimelist.net/anime/48997/Fantasy_Bishoujo_Juniku_Ojisan_to/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1430/120065.jpg?s=3aabe7f898d305c4c0880cc18f6ee16d",
            },
            {
                title: "Sabikui Bisco",
                link: "https://myanimelist.net/anime/48414/Sabikui_Bisco/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1446/118840.jpg?s=e6e40f70380f8b8221ee31d4467680dd",
            },
            {
                title: "Shingeki no Kyojin: The Final Season",
                link: "https://myanimelist.net/anime/40028/Shingeki_no_Kyojin__The_Final_Season/episode/16",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1000/110531.jpg?s=6586b8057e9adef10937de6243c97f40",
            },
            {
                title: "Sabiiro no Armor: Reimei",
                link: "https://myanimelist.net/anime/39917/Sabiiro_no_Armor__Reimei/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1263/120362.jpg?s=352b80b760343b010677afdafe4b52e1",
            },
            {
                title: "Boruto: Naruto Next Generations",
                link: "https://myanimelist.net/anime/34566/Boruto__Naruto_Next_Generations/episode/242",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/9/84460.jpg?s=225f30243444d88a54c09f031106951e",
            },
            {
                title: "Shenmue the Animation",
                link: "https://myanimelist.net/anime/42808/Shenmue_the_Animation/episode/8",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1427/120586.jpg?s=14ed0337be651a9812fe01413e025f02",
            },
            {
                title: "Kaijin Kaihatsu-bu no Kuroitsu-san",
                link: "https://myanimelist.net/anime/49385/Kaijin_Kaihatsu-bu_no_Kuroitsu-san/episode/11",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1975/121513.jpg?s=51a0fc657fe704378e9829512de06cdc",
            },
            {
                title: "Ryman's Club",
                link: "https://myanimelist.net/anime/50185/Rymans_Club/episode/9",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1140/120215.jpg?s=9eb3f86db24a9f868e8fa8d165a5afdf",
            },
            {
                title: "Genjitsu Shugi Yuusha no Oukoku Saikenki Part 2",
                link: "https://myanimelist.net/anime/49930/Genjitsu_Shugi_Yuusha_no_Oukoku_Saikenki_Part_2/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1088/120068.jpg?s=6801a42e4ecfe9509e12d24589aa937a",
            },
            {
                title: "Akebi-chan no Sailor-fuku",
                link: "https://myanimelist.net/anime/48553/Akebi-chan_no_Sailor-fuku/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1820/120520.jpg?s=b48cbc22b04f8b2e7b381ea26c1d9ad4",
            },
            {
                title: "Sono Bisque Doll wa Koi wo Suru",
                link: "https://myanimelist.net/anime/48736/Sono_Bisque_Doll_wa_Koi_wo_Suru/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1179/119897.jpg?s=c4bd80e86553f4e250b01c74933fa153",
            },
            {
                title: "Shikkakumon no Saikyou Kenja",
                link: "https://myanimelist.net/anime/47161/Shikkakumon_no_Saikyou_Kenja/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1132/120388.jpg?s=0055fbea6d3f0500f9fc31f24ebc6690",
            },
            {
                title: "Hanyou no Yashahime: Sengoku Otogizoushi",
                link: "https://myanimelist.net/anime/41911/Hanyou_no_Yashahime__Sengoku_Otogizoushi/episode/48",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1005/114781.jpg?s=d1c0882216795a240278372955f19a62",
            },
            {
                title: "Cue!",
                link: "https://myanimelist.net/anime/43735/Cue/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1039/120173.jpg?s=2aab49f0f8a7d6e5f757de967af33f44",
            },
            {
                title: "Platinum End",
                link: "https://myanimelist.net/anime/44961/Platinum_End/episode/24",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1992/116576.jpg?s=e28806dd92657e4041f70bc12cd45b6f",
            },
            {
                title: "Ousama Ranking",
                link: "https://myanimelist.net/anime/40834/Ousama_Ranking/episode/23",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1347/117616.jpg?s=e14b13f9aec826f799f31035d795506f",
            },
            {
                title: "Estab-Life: Great Escape",
                link: "https://myanimelist.net/anime/50862/Estab-Life__Great_Escape/episode/2",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1811/121606.jpg?s=45cb11005aa0047ecaf7cc51cb4e1c60",
            },
            {
                title: "Tokyo 24-ku",
                link: "https://myanimelist.net/anime/50204/Tokyo_24-ku/episode/10",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1442/120112.jpg?s=bb186ba7697074bdd6f553e7e7185430",
            },
            {
                title: "Orient",
                link: "https://myanimelist.net/anime/45560/Orient/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1576/119361.jpg?s=4ddae5e70b1019c0f61154fe0e6c18a3",
            },
            {
                title: "Koroshi Ai",
                link: "https://myanimelist.net/anime/44516/Koroshi_Ai/episode/11",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1485/119329.jpg?s=d229afdb2514d54cb4a08ef4deea5e89",
            },
            {
                title: "Leadale no Daichi nite",
                link: "https://myanimelist.net/anime/48239/Leadale_no_Daichi_nite/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1671/120628.jpg?s=b2243ad240a48c2d6f5e54680e1d834f",
            },
            {
                title: "86",
                link: "https://myanimelist.net/anime/41457/86/episode/23",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1987/117507.jpg?s=66c37f94f698ce0ec6762b3290f370d1",
            },
            {
                title: "Shuumatsu no Harem",
                link: "https://myanimelist.net/anime/41946/Shuumatsu_no_Harem/episode/11",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1491/117296.jpg?s=8bfe620ff853e6095b1acf141d205632",
            },
            {
                title: "Detective Conan",
                link: "https://myanimelist.net/anime/235/Detective_Conan/episode/1038",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/7/75199.jpg?s=f125f8c9fac4e0694454c0b17d0d8905",
            },
            {
                title: "Atasha Kawajiri Kodama Da yo: Dangerous Lifehacker no Tadareta Seikatsu",
                link: "https://myanimelist.net/anime/49780/Atasha_Kawajiri_Kodama_Da_yo__Dangerous_Lifehacker_no_Tadareta_Seikatsu/episode/9",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1996/120580.jpg?s=ec38214eb6513811804da915041821c6",
            },
            {
                title: "Tales of Zestiria the Cross",
                link: "https://myanimelist.net/anime/30911/Tales_of_Zestiria_the_Cross/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/3/79271.jpg?s=7f213c112ea4234dc15e65038d9c7c86",
            },
            {
                title: "Azur Lane",
                link: "https://myanimelist.net/anime/38328/Azur_Lane/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1106/111620.jpg?s=3a75fcb1986b60cb88d9165e2e28cb3a",
            },
            {
                title: "Kaguya-sama wa Kokurasetai? Tensai-tachi no Renai Zunousen",
                link: "https://myanimelist.net/anime/40591/Kaguya-sama_wa_Kokurasetai_Tensai-tachi_no_Renai_Zunousen/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1764/106659.jpg?s=ff7fd7ed3eafa65de2984df228c5e206",
            },
            {
                title: "Subarashiki Kono Sekai The Animation",
                link: "https://myanimelist.net/anime/42307/Subarashiki_Kono_Sekai_The_Animation/episode/12",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1016/111566.jpg?s=a2dad68b8e6523e3318c1d20e08db08d",
            },
            {
                title: "Fugou Keiji: Balance:Unlimited",
                link: "https://myanimelist.net/anime/41120/Fugou_Keiji__Balance_Unlimited/episode/11",
                img: "https://cdn.myanimelist.net/r/108x163/images/anime/1066/106556.jpg?s=9064d94b5fff3cca8fd62819169dab9d",
            },
        ],
    },
    {
        title: "Most Popular Anime Trailers",
        linkTitle: "View More",
        link: "https://myanimelist.net/watch/promotion/popular",
        Atom: TrailerSlide,
        slider: true,
        slides: 3.25,
        items: [
            {
                title: "Shingeki no Kyojin",
                link: "https://myanimelist.net/anime/16498/Shingeki_no_Kyojin",
                img: "https://cdn.myanimelist.net/images/anime/10/47347.jpg",
                ytLink: "https://www.youtube.com/embed/KKzmOh4SuBc?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Death Note",
                link: "https://myanimelist.net/anime/1535/Death_Note",
                img: "https://cdn.myanimelist.net/images/anime/9/9453.jpg",
                ytLink: "https://www.youtube.com/embed/4TrEY9Zs_FQ?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Fullmetal Alchemist: Brotherhood",
                link: "https://myanimelist.net/anime/5114/Fullmetal_Alchemist__Brotherhood",
                img: "https://cdn.myanimelist.net/images/anime/1223/96541.jpg",
                ytLink: "https://www.youtube.com/embed/--IcmZkvL0Q?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "One Punch Man",
                link: "https://myanimelist.net/anime/30276/One_Punch_Man",
                img: "https://cdn.myanimelist.net/images/anime/12/76049.jpg",
                ytLink: "https://www.youtube.com/embed/6Bdb1V0Io_g?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Sword Art Online",
                link: "https://myanimelist.net/anime/11757/Sword_Art_Online",
                img: "https://cdn.myanimelist.net/images/anime/11/39717.jpg",
                ytLink: "https://www.youtube.com/embed/6ohYYtxfDCg?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Boku no Hero Academia",
                link: "https://myanimelist.net/anime/31964/Boku_no_Hero_Academia",
                img: "https://cdn.myanimelist.net/images/anime/10/78745.jpg",
                ytLink: "https://www.youtube.com/embed/o0L1YC9YgxM?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Tokyo Ghoul",
                link: "https://myanimelist.net/anime/22319/Tokyo_Ghoul",
                img: "https://cdn.myanimelist.net/images/anime/5/64449.jpg",
                ytLink: "https://www.youtube.com/embed/vGuQeQsoRgU?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Naruto",
                link: "https://myanimelist.net/anime/20/Naruto",
                img: "https://cdn.myanimelist.net/images/anime/13/17405.jpg",
                ytLink: "https://www.youtube.com/embed/j2hiC9BmJlQ?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Kimetsu no Yaiba",
                link: "https://myanimelist.net/anime/38000/Kimetsu_no_Yaiba",
                img: "https://cdn.myanimelist.net/images/anime/1286/99889.jpg",
                ytLink: "https://www.youtube.com/embed/j6coxXGu6mM?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Hunter x Hunter (2011)",
                link: "https://myanimelist.net/anime/11061/Hunter_x_Hunter_2011",
                img: "https://cdn.myanimelist.net/images/anime/1337/99013.jpg",
                ytLink: "https://www.youtube.com/embed/yBTW-O_BiB0?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Kimi no Na wa.",
                link: "https://myanimelist.net/anime/32281/Kimi_no_Na_wa",
                img: "https://cdn.myanimelist.net/images/anime/5/87048.jpg",
                ytLink: "https://www.youtube.com/embed/RBBrZ3d2sJE?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Shingeki no Kyojin Season 2",
                link: "https://myanimelist.net/anime/25777/Shingeki_no_Kyojin_Season_2",
                img: "https://cdn.myanimelist.net/images/anime/4/84177.jpg",
                ytLink: "https://www.youtube.com/embed/e8IthrzLP94?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Steins;Gate",
                link: "https://myanimelist.net/anime/9253/Steins_Gate",
                img: "https://cdn.myanimelist.net/images/anime/5/73199.jpg",
                ytLink: "https://www.youtube.com/embed/gaOvEIkeyzU?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Boku no Hero Academia 2nd Season",
                link: "https://myanimelist.net/anime/33486/Boku_no_Hero_Academia_2nd_Season",
                img: "https://cdn.myanimelist.net/images/anime/12/85221.jpg",
                ytLink: "https://www.youtube.com/embed/0rBiwqTqHEU?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "No Game No Life",
                link: "https://myanimelist.net/anime/19815/No_Game_No_Life",
                img: "https://cdn.myanimelist.net/images/anime/1074/111944.jpg",
                ytLink: "https://www.youtube.com/embed/TqMCYf1FibU?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Naruto: Shippuuden",
                link: "https://myanimelist.net/anime/1735/Naruto__Shippuuden",
                img: "https://cdn.myanimelist.net/images/anime/5/17407.jpg",
                ytLink: "https://www.youtube.com/embed/1dy2zPPrKD0?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Toradora!",
                link: "https://myanimelist.net/anime/4224/Toradora",
                img: "https://cdn.myanimelist.net/images/anime/13/22128.jpg",
                ytLink: "https://www.youtube.com/embed/ya570uUgQNc?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Koe no Katachi",
                link: "https://myanimelist.net/anime/28851/Koe_no_Katachi",
                img: "https://cdn.myanimelist.net/images/anime/1122/96435.jpg",
                ytLink: "https://www.youtube.com/embed/NbElewFH464?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Noragami",
                link: "https://myanimelist.net/anime/20507/Noragami",
                img: "https://cdn.myanimelist.net/images/anime/9/77809.jpg",
                ytLink: "https://www.youtube.com/embed/KjSZ7X-kvi0?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Shingeki no Kyojin Season 3",
                link: "https://myanimelist.net/anime/35760/Shingeki_no_Kyojin_Season_3",
                img: "https://cdn.myanimelist.net/images/anime/1173/92110.jpg",
                ytLink: "https://www.youtube.com/embed/r8EVptqU6zE?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Shigatsu wa Kimi no Uso",
                link: "https://myanimelist.net/anime/23273/Shigatsu_wa_Kimi_no_Uso",
                img: "https://cdn.myanimelist.net/images/anime/3/67177.jpg",
                ytLink: "https://www.youtube.com/embed/Sk39zsayK_0?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Re:Zero kara Hajimeru Isekai Seikatsu",
                link: "https://myanimelist.net/anime/31240/Re_Zero_kara_Hajimeru_Isekai_Seikatsu",
                img: "https://cdn.myanimelist.net/images/anime/11/79410.jpg",
                ytLink: "https://www.youtube.com/embed/vFfXjuVA1Jk?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Angel Beats!",
                link: "https://myanimelist.net/anime/6547/Angel_Beats",
                img: "https://cdn.myanimelist.net/images/anime/1244/111115.jpg",
                ytLink: "https://www.youtube.com/embed/zkY-sG6crKI?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Boku no Hero Academia 3rd Season",
                link: "https://myanimelist.net/anime/36456/Boku_no_Hero_Academia_3rd_Season",
                img: "https://cdn.myanimelist.net/images/anime/1319/92084.jpg",
                ytLink: "https://www.youtube.com/embed/_gWE61ujBQw?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "One Piece",
                link: "https://myanimelist.net/anime/21/One_Piece",
                img: "https://cdn.myanimelist.net/images/anime/6/73245.jpg",
                ytLink: "https://www.youtube.com/embed/-tviZNY6CSw?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Akame ga Kill!",
                link: "https://myanimelist.net/anime/22199/Akame_ga_Kill",
                img: "https://cdn.myanimelist.net/images/anime/1429/95946.jpg",
                ytLink: "https://www.youtube.com/embed/HOB4GZ1S1Wo?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Mirai Nikki (TV)",
                link: "https://myanimelist.net/anime/10620/Mirai_Nikki_TV",
                img: "https://cdn.myanimelist.net/images/anime/13/33465.jpg",
                ytLink: "https://www.youtube.com/embed/52P0DM-JDMg?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Nanatsu no Taizai",
                link: "https://myanimelist.net/anime/23755/Nanatsu_no_Taizai",
                img: "https://cdn.myanimelist.net/images/anime/8/65409.jpg",
                ytLink: "https://www.youtube.com/embed/wxcvbL6o55M?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Boku dake ga Inai Machi",
                link: "https://myanimelist.net/anime/31043/Boku_dake_ga_Inai_Machi",
                img: "https://cdn.myanimelist.net/images/anime/10/77957.jpg",
                ytLink: "https://www.youtube.com/embed/GF5tqAD2ucg?enablejsapi=1&wmode=opaque&autoplay=1",
            },
            {
                title: "Shingeki no Kyojin Season 3 Part 2",
                link: "https://myanimelist.net/anime/38524/Shingeki_no_Kyojin_Season_3_Part_2",
                img: "https://cdn.myanimelist.net/images/anime/1517/100633.jpg",
                ytLink: "https://www.youtube.com/embed/s9PZFZgAqeM?enablejsapi=1&wmode=opaque&autoplay=1",
            },
        ],
    },
    {
        title: "Anime & Manga News",
        linkTitle: "View More",
        link: "https://myanimelist.net/news",
        Atom: MiniArticle,
        items: [
            {
                link: "https://myanimelist.net/news/66033513",
                img: "https://cdn.myanimelist.net/r/50x70/s/common/uploaded_files/1648786345-da2ac943dbd7d88d9d733052d372333a.jpeg?s=d6cfacda57f68d9b7e1f73a5c6aa7361",
                title: "'Shinka no Mi: Shiranai Uchi ni Kachigumi Jinsei' Gets New TV Anime",
                text: "The official website of the Shinka no Mi: Shiranai Uchi ni Kachigumi Jinsei (The Fruit of Evolution: Before I Knew It, My Life Had It Made) anime series announced a new television anime on Friday, titled Shin Shinka no Mi: Shiranai Uchi ni Kachigumi...",
            },
            {
                link: "https://myanimelist.net/news/66029814",
                img: "https://cdn.myanimelist.net/r/50x70/s/common/uploaded_files/1648742237-ed6c28ee37be163acdbb82a93895da7a.jpeg?s=2b0ddd34ddaca6660704eaf3f62bc7e9",
                title: "'Arifureta Shokugyou de Sekai Saikyou' 2nd Season Announces OVA for Summer 2022",
                text: "The 12th and final episode of Arifureta Shokugyou de Sekai Saikyou (Arifureta: From Commonplace to World's Strongest) 2nd season announced on Thursday that it will receive an original video animation in Summer 2022. Akira Iwanaga (Kingdom 2nd Season)...",
            },
            {
                link: "https://myanimelist.net/news/66026550",
                img: "https://cdn.myanimelist.net/r/50x70/s/common/uploaded_files/1648700269-dbbc3b9bc452adc5aebd5475775bc75f.jpeg?s=9a5e4bd8487a23ed87e0e9e96ee00ba4",
                title: "'Mobile Suit Gundam: Cucuruz Doan's Island' Reveals Supporting Cast",
                text: "The official website of the Kidou Senshi Gundam: Cucuruz Doan no Shima (Mobile Suit Gundam: Cucuruz Doan's Island) announced on Thursday five additional cast members, who're part of the Southern Cross team. The anime is scheduled to open in Japanese...",
            },
            {
                link: "https://myanimelist.net/news/66019667",
                img: "https://cdn.myanimelist.net/r/50x70/s/common/uploaded_files/1648608701-78bfc43f0977a0e7c7ead066eb1fb52c.jpeg?s=1af576ba083940798ceb13fc701bd9e1",
                title: "'Kidou Senshi Gundam: Suisei no Majo' Unveils Teaser Promo, Prologue for Summer 2022",
                text: "The 3rd Gundam Conference unveiled a teaser visual (pictured) and teaser promotional video for the Kidou Senshi Gundam: Suisei no Majo (Mobile Suit Gundam: The Witch from Mercury) television anime on Tuesday. The teaser visual and promo depict the se...",
            },
        ],
    },
    {
        title: "Recent Anime Discussions",
        linkTitle: "View More",
        link: "https://myanimelist.net/forum/",
        Atom: DiscussionLink,
        items: [
            {
                link: "https://myanimelist.net/forum/?topicid=2002807",
                title: "Did someone else get you into anime or did you do it yourself?",
                userLink: "https://myanimelist.net/profile/fluffycow17",
                username: "fluffycow17",
            },
            {
                link: "https://myanimelist.net/forum/?topicid=2005251",
                title: "Is the time of romantic school dramas over?",
                userLink: "https://myanimelist.net/profile/dadnaya",
                username: "dadnaya",
            },
            {
                link: "https://myanimelist.net/forum/?topicid=2005271",
                title: "Would you rather",
                userLink: "https://myanimelist.net/profile/YVREJN",
                username: "YVREJN",
            },
            {
                link: "https://myanimelist.net/forum/?topicid=2005036",
                title: "How do you decide on what you're going to watch next?",
                userLink: "https://myanimelist.net/profile/Animaay",
                username: "Animaay",
            },
        ],
    },
    {
        title: "Featured Articles",
        linkTitle: "View More",
        link: "https://myanimelist.net/forum/",
        Atom: MiniArticle,
        items: [
            {
                link: "https://myanimelist.net/featured/2377/%E2%80%9CSword_Art_Online%E2%80%9D_VR_Party_Report",
                img: "https://cdn.myanimelist.net/r/50x70/s/common/uploaded_files/1646796845-d4559b97ee40e30f5dc2b6cdadff928a.jpeg?s=f07e000be76e83dbb316f1852d3c1858",
                title: "“Sword Art Online” VR Party Report!",
                text: "The world of SAO comes to VR!",
                info: '<p class="info pr8">                 by <a href="https://myanimelist.net/profile/MAL_editing_team">MAL_editing_team</a>               </p>                                             <p class="di-tc pv pr8">                   <b>8,624</b> views                 </p>               <div class="tags">                     <div class="tags-inner"><span class="tag tag-color-feature-advertorial">Advertorial</span></div>                   </div>',
            },
            {
                link: "https://myanimelist.net/featured/2372/Weiss_Schwarz_is_a_treat_for_any_anime_fan",
                img: "https://cdn.myanimelist.net/r/50x70/s/common/uploaded_files/1639381057-40a1a4a17135da271f531570c730efd7.png?s=c5deae3e17361e08fbb7088570d4a399",
                title: "Weiss Schwarz is a treat for any anime fan!",
                text: "Vivid action, thrilling adventures, and zany antics that make you LOL – the fantastical world of anime offers us a slight reprieve from the mundanity of our daily lives. Dive deeper into your favorite worlds and relive the climactic scenes only in Weiss Schwarz (stylized: Weiß Schwarz)!",
                info: '<p class="info pr8">                 by <a href="https://myanimelist.net/profile/MAL_editing_team">MAL_editing_team</a>               </p>                                             <p class="di-tc pv pr8">                   <b>25,918</b> views                 </p>               <div class="tags">                     <div class="tags-inner"><span class="tag tag-color-feature-advertorial">Advertorial</span></div>                   </div>',
            },
            {
                link: "https://myanimelist.net/featured/2370/Top_10_Finalists_Which_web_novel_do_you_want_to_read_as_manga",
                img: "https://cdn.myanimelist.net/r/50x70/s/common/uploaded_files/1636829781-4a91675c145e00d1c3dd337950ad4825.png?s=77f7e4448398de63a800d3d00569a377",
                title: "Top 10 Finalists! Which web novel do you want to read as manga?",
                text: "Here are the 10 finalist novels from the MAL x Honeyfeed Writing Contest! Try them out and let us know which web novels you want to see brought to life as published manga.",
                info: '<p class="info pr8">                 by <a href="https://myanimelist.net/profile/MAL_editing_team">MAL_editing_team</a>               </p>                                             <p class="di-tc pv pr8">                   <b>49,221</b> views                 </p>',
            },
            {
                link: "https://myanimelist.net/featured/2360/Introducing_the_Aniclub_Scene_with_How_Not_to_Summon_a_Demon_Lord_%CE%A9",
                img: "https://cdn.myanimelist.net/r/50x70/s/common/uploaded_files/1623894500-7e105312e3ac46ae2a12d77842cc87b8.jpeg?s=73d7e6eb3de4a386d397b95956a55258",
                title: "Introducing the Aniclub Scene with 'How Not to Summon a Demon Lord Ω'",
                text: "What is Aniclub? And what does it have to do with 'How Not to Summon a Demon Lord Ω'? MOTSU wants you to know with these eight remixes.",
                info: '<p class="info pr8">                 by <a href="https://myanimelist.net/profile/MAL_editing_team">MAL_editing_team</a>               </p>                                             <p class="di-tc pv pr8">                   <b>44,714</b> views                 </p>',
            },
        ],
    },
    {
        title: "Latest Anime Reviews",
        linkTitle: "View More",
        link: "https://myanimelist.net/reviews.php?t=anime",
        Atom: MiniArticle,
        items: [
            {
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1561/115660.jpg?s=79acc51ecc77b35fe5f61096dec935c3",
                link: "https://myanimelist.net/anime/1887/Lucky☆Star",
                rating: "Overall Rating: 5",
                title: "Lucky☆Star",
                text: "if i can't finish it, it's not that great right?\naround episode 15 it became impossible to finish this anime without skipping a lot\n\nthe main problem is that there is no overall plot, every episode is about casual things that happen in our life like missing a bus, so after a while it becomes repetitive \nand this anime is just SOOO nice! nothing...\n                          read more\n                        ",
                reviewLink: "/reviews.php?id=440386",
                author: '1 hour ago             by             <a href="https://myanimelist.net/profile/AgentBishop" alt="AgentBishop">               AgentBishop             </a>',
            },
            {
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/5/66083.jpg?s=59ab3e9362a2bbed54ae5420b27032bb",
                link: "https://myanimelist.net/anime/23289/Gekkan_Shoujo_Nozaki-kun",
                rating: "Overall Rating: 10",
                title: "Gekkan Shoujo Nozaki-kun",
                text: "This is one of the funniest anime I've ever seen! It's a great satire of the Shojo genre, with each character being a complete idiot and always, at one point, be the straight man in the comedy. The main cast is a joy to watch; all of them have their moment to shine. The anime unfortunately ends on a cliche note and no hopes for a season 2, but I implore...\n                          read more\n                        ",
                reviewLink: "/reviews.php?id=440385",
                author: '1 hour ago             by             <a href="https://myanimelist.net/profile/milfenjoyer358" alt="milfenjoyer358">               milfenjoyer358             </a>',
            },
            {
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1418/107954.jpg?s=14409bdc75985f4b2a9d0fbe2883cd78",
                link: "https://myanimelist.net/anime/40052/Great_Pretender",
                rating: "Overall Rating: 7",
                title: "Great Pretender",
                text: "A show about a group of conmen, their individual traumas and 4 cases related to each one.\n\nI'll start with the good things. The cases and subplots were mostly interesting and the show overall entertaining. Each case was related to one of the four main characters' pasts and the scams were smart and thought through. The villains were really hateable...\n                          read more\n                        ",
                reviewLink: "/reviews.php?id=440384",
                author: '1 hour ago             by             <a href="https://myanimelist.net/profile/nickmsakis" alt="nickmsakis">               nickmsakis             </a>',
            },
            {
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1948/120625.jpg?s=53584a9c479506f8c779fb38b02d1a6d",
                link: "https://myanimelist.net/anime/48583/Shingeki_no_Kyojin__The_Final_Season_Part_2",
                rating: "Overall Rating: 10",
                title: "Shingeki no Kyojin: The Final Season Part 2",
                text: "one more season of AOT ends, and leaves us once again the satisfaction of being able to call this a masterpiece, this review does not contain manga spoilers, read it calmly.\n\nAt the level of animation and drawing I think there is nothing to discuss, there was an incredible improvement compared to the first part, the drawings were much more polished...\n                          read more\n                        ",
                reviewLink: "/reviews.php?id=440382",
                author: '1 hour ago             by             <a href="https://myanimelist.net/profile/maldonado3008" alt="maldonado3008">               maldonado3008             </a>',
            },
        ],
    },
    {
        title: "Latest Anime Recommendations",
        linkTitle: "View More",
        link: "https://myanimelist.net/recommendations.php?s=recentrecs&t=anime",
        Atom: RecommendationLink,
        items: [
            {
                first: {
                    img: "https://cdn.myanimelist.net/r/50x70/images/anime/10/47347.jpg?s=29949c6e892df123f0b0563e836d3d98",
                    link: "https://myanimelist.net/anime/16498/Shingeki_no_Kyojin",
                    title: "Shingeki no Kyojin",
                },
                second: {
                    img: "https://cdn.myanimelist.net/r/50x70/images/anime/4/84177.jpg?s=74f2f396ab23eee08691546aaa2c6fad",
                    link: "https://myanimelist.net/anime/25777/Shingeki_no_Kyojin_Season_2",
                    title: "Shingeki no Kyojin Season 2",
                },
                text: "Same goated series",
                recom: 'Anime rec by <a href="https://myanimelist.net/profile/Michael_S1230">Michael_S1230</a>           - 5 hours ago',
            },
            {
                first: {
                    img: "https://cdn.myanimelist.net/r/50x70/images/anime/8/55411.jpg?s=df971927b6d97ec0bb76a3e8be4efbd0",
                    link: "https://myanimelist.net/anime/2389/Kagaku_Ninja-tai_Gatchaman",
                    title: "Kagaku Ninja-tai Gatchaman",
                },
                second: {
                    img: "https://cdn.myanimelist.net/r/50x70/images/anime/7/60395.jpg?s=507abc31d244aee09ea284f945b0a761",
                    link: "https://myanimelist.net/anime/4810/Shinzou_Ningen_Casshern",
                    title: "Shinzou Ningen Casshern",
                },
                text: "Both are classic and influental anime superheroes by the same studio and creator. Both features superheroes that wears helmet and rides on planes and vehicles. Both features alot of melodrama and action",
                recom: 'Anime rec by <a href="https://myanimelist.net/profile/Sinister_Garbage">Sinister_Garbage</a>           - 7 hours ago',
            },
            {
                first: {
                    img: "https://cdn.myanimelist.net/r/50x70/images/anime/8/55411.jpg?s=df971927b6d97ec0bb76a3e8be4efbd0",
                    link: "https://myanimelist.net/anime/2389/Kagaku_Ninja-tai_Gatchaman",
                    title: "Kagaku Ninja-tai Gatchaman",
                },
                second: {
                    img: "https://cdn.myanimelist.net/r/50x70/images/anime/9/60393.jpg?s=a7c5289dcf967c1531d42768170a3f67",
                    link: "https://myanimelist.net/anime/4808/Hurricane_Polymar",
                    title: "Hurricane Polymar",
                },
                text: "Hurricane Polymar is mostly known as a Gatchaman clone as both have similar designs being a caped superhero with a helmet and both have abilities to create a windstorm. Although Hurricane had more power...                       read more",
                recom: 'Anime rec by <a href="https://myanimelist.net/profile/Sinister_Garbage">Sinister_Garbage</a>           - 7 hours ago',
            },
            {
                first: {
                    img: "https://cdn.myanimelist.net/r/50x70/images/anime/1880/118484.jpg?s=73b91a0146dfa5fadc5ff9f870c72741",
                    link: "https://myanimelist.net/anime/41025/Fumetsu_no_Anata_e",
                    title: "Fumetsu no Anata e",
                },
                second: {
                    img: "https://cdn.myanimelist.net/r/50x70/images/anime/1401/118483.jpg?s=892f8e6c7e52a39635eb4eb5460d02f5",
                    link: "https://myanimelist.net/anime/48580/Vanitas_no_Karte",
                    title: "Vanitas no Karte",
                },
                text: "Both are animes about the duet/protagonist meeting new people in hope to finish their mission, the characters have tragic backgrounds and they usually have to face them somehow. The characters usually...                       read more",
                recom: 'Anime rec by <a href="https://myanimelist.net/profile/Caromel3">Caromel3</a>           - 7 hours ago',
            },
        ],
    },
];

export const RightWidgets = [
    {
        title: "Top Airing Anime",
        link: "https://myanimelist.net/topanime.php?type=airing",
        items: [
            {
                ranking: 1,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/6/73245.jpg?s=f792b8c9e28534ae455d06b15e686a14",
                link: "https://myanimelist.net/anime/21/One_Piece",
                title: "One Piece",
                info: "TV,             0 eps,             scored 8.63",
                members: "1,825,823 members",
            },
            {
                ranking: 2,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1430/118919.jpg?s=de573cafabe2da1f62b85293bc913651",
                link: "https://myanimelist.net/anime/43608/Kaguya-sama_wa_Kokurasetai__Ultra_Romantic",
                title: "Kaguya-sama wa Kokurasetai: Ultra Romantic",
                info: "TV,             0 eps,             scored 8.50",
                members: "325,164 members",
            },
            {
                ranking: 3,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1259/110227.jpg?s=08c77f58ab974a8fc36af5e2eac9040a",
                link: "https://myanimelist.net/anime/44042/Holo_no_Graffiti",
                title: "Holo no Graffiti",
                info: "ONA,             0 eps,             scored 8.39",
                members: "44,155 members",
            },
            {
                ranking: 4,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/7/75199.jpg?s=529dd40c117676c23a713a83ffc0a87f",
                link: "https://myanimelist.net/anime/235/Detective_Conan",
                title: "Detective Conan",
                info: "TV,             0 eps,             scored 8.16",
                members: "303,128 members",
            },
            {
                ranking: 5,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1586/121947.jpg?s=12dd98991eff39813c800aba9ddb2eee",
                link: "https://myanimelist.net/anime/48916/Love_Live_Nijigasaki_Gakuen_School_Idol_Doukoukai_2nd_Season",
                title: "Love Live! Nijigasaki Gakuen School Idol Doukoukai 2nd Season",
                info: "TV,             0 eps,             scored 8.03",
                members: "18,647 members",
            },
        ],
    },
    {
        title: "Top Upcoming Anime",
        link: "https://myanimelist.net/topanime.php?type=upcoming",
        items: [
            {
                ranking: 1,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1632/110707.jpg?s=e489bf840c9c4c9163591db80d2f063f",
                link: "https://myanimelist.net/anime/44511/Chainsaw_Man",
                title: "Chainsaw Man",
                info: "TV,             0 eps,             scored N/A",
                members: "369,790 members",
            },
            {
                ranking: 2,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1440/121382.jpg?s=71269026f2f9ddbee33406e4bfdb2393",
                link: "https://myanimelist.net/anime/50265/Spy_x_Family",
                title: "Spy x Family",
                info: "TV,             0 eps,             scored N/A",
                members: "247,315 members",
            },
            {
                ranking: 3,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1406/104631.jpg?s=f6d480878204e18ad25c5cb7d3b62f47",
                link: "https://myanimelist.net/anime/40357/Tate_no_Yuusha_no_Nariagari_Season_3",
                title: "Tate no Yuusha no Nariagari Season 3",
                info: "TV,             0 eps,             scored N/A",
                members: "211,173 members",
            },
            {
                ranking: 4,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1543/120053.jpg?s=8e4a0f55026ed698468d8cea54df1d5f",
                link: "https://myanimelist.net/anime/48413/Hataraku_Maou-sama_2nd_Season",
                title: "Hataraku Maou-sama! 2nd Season",
                info: "TV,             0 eps,             scored N/A",
                members: "202,829 members",
            },
            {
                ranking: 5,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1427/120522.jpg?s=aa9f8bf17f7fe4019aa69d7382bf2231",
                link: "https://myanimelist.net/anime/42963/Kanojo_Okarishimasu_2nd_Season",
                title: "Kanojo, Okarishimasu 2nd Season",
                info: "TV,             0 eps,             scored N/A",
                members: "190,775 members",
            },
        ],
    },
    {
        title: "Most Popular Anime",
        link: "https://myanimelist.net/topanime.php?type=bypopularity",
        items: [
            {
                ranking: 1,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/10/47347.jpg?s=29949c6e892df123f0b0563e836d3d98",
                link: "https://myanimelist.net/anime/16498/Shingeki_no_Kyojin",
                title: "Shingeki no Kyojin",
                info: "TV,             25 eps,             scored 8.53",
                members: "3,355,161 members",
            },
            {
                ranking: 2,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/9/9453.jpg?s=b89e80691ac5cc0610847ccbe0b8424a",
                link: "https://myanimelist.net/anime/1535/Death_Note",
                title: "Death Note",
                info: "TV,             37 eps,             scored 8.63",
                members: "3,343,879 members",
            },
            {
                ranking: 3,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1223/96541.jpg?s=faffcb677a5eacd17bf761edd78bfb3f",
                link: "https://myanimelist.net/anime/5114/Fullmetal_Alchemist__Brotherhood",
                title: "Fullmetal Alchemist: Brotherhood",
                info: "TV,             64 eps,             scored 9.15",
                members: "2,832,156 members",
            },
            {
                ranking: 4,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/12/76049.jpg?s=40b6c7dbbbb94c44675116d301150078",
                link: "https://myanimelist.net/anime/30276/One_Punch_Man",
                title: "One Punch Man",
                info: "TV,             12 eps,             scored 8.51",
                members: "2,742,111 members",
            },
            {
                ranking: 5,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/11/39717.jpg?s=5908e8051487fb8468d5fca779f8f00d",
                link: "https://myanimelist.net/anime/11757/Sword_Art_Online",
                title: "Sword Art Online",
                info: "TV,             25 eps,             scored 7.20",
                members: "2,710,247 members",
            },
            {
                ranking: 6,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/10/78745.jpg?s=8ea4cb2e8a861e63757d3c05aa5d32c2",
                link: "https://myanimelist.net/anime/31964/Boku_no_Hero_Academia",
                title: "Boku no Hero Academia",
                info: "TV,             13 eps,             scored 7.95",
                members: "2,580,141 members",
            },
            {
                ranking: 7,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/5/64449.jpg?s=f1af76501ac3d4238170191d5e0679f2",
                link: "https://myanimelist.net/anime/22319/Tokyo_Ghoul",
                title: "Tokyo Ghoul",
                info: "TV,             12 eps,             scored 7.80",
                members: "2,445,527 members",
            },
            {
                ranking: 8,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/13/17405.jpg?s=59241469eb470604a792add6fbe7cce6",
                link: "https://myanimelist.net/anime/20/Naruto",
                title: "Naruto",
                info: "TV,             220 eps,             scored 7.97",
                members: "2,435,509 members",
            },
            {
                ranking: 9,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1286/99889.jpg?s=e497d08bef31ae412e314b90a54acfda",
                link: "https://myanimelist.net/anime/38000/Kimetsu_no_Yaiba",
                title: "Kimetsu no Yaiba",
                info: "TV,             26 eps,             scored 8.55",
                members: "2,354,934 members",
            },
            {
                ranking: 10,
                img: "https://cdn.myanimelist.net/r/50x70/images/anime/1337/99013.jpg?s=1838e905a0aa3542a009fbcf78000701",
                link: "https://myanimelist.net/anime/11061/Hunter_x_Hunter_2011",
                title: "Hunter x Hunter (2011)",
                info: "TV,             148 eps,             scored 9.05",
                members: "2,313,018 members",
            },
        ],
    },
];
